module.exports = __webpack_public_path__ + "assets/img/open_chat.a408347d.png";